
import React, { useState } from 'react'
import * as locCon from '../LocalConstants';
import CustomText from '../elements/CustomText';
import { RefContextLanguage } from '../providers/LanguageProvider';
import * as libCon from '../community-hats-js-library/Constants';
import CollectionStatus from '../elements/CollectionStatus';
import { SimpleCopyField } from '../elements/SimpleStoreCopyField';
import { RefPercelptualSurveyStatus, refreshParticipant } from '../hooks/BundleDeviceHooks';
import { showErrorDialogByCode } from '../utils/dialogFunctions';
import { showNotification } from '../utils/generalFunctions';
import CustomSpin from '../elements/CustomSpin';
import { CustomPrimaryButtonWithDisability } from '../elements/CustomButton';
import { RefATObjectId, RefATOField } from '../hooks/StoreHooks';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import { formatDistanceShort, formatToStudyLocationReadable } from '../community-hats-js-library/utils/dateFunctions';

function PerceptualSurveyStatusViewer({ includeTitle = true }) {
    const i18n = RefContextLanguage()




    const participantId = RefATObjectId(locCon.AT_OBJECT_PARTICIPANT)
    const [status, message] = RefPercelptualSurveyStatus()

    const lastUploaded = RefATOField(locCon.AT_OBJECT_PARTICIPANT, libCon.ATF_LAST_UPLOADED_PERCEPTUAL_SURVEY)


    const [isSynching, setisSynching] = useState(false)


    const refreshRecords = async () => {
        setisSynching(true)
        let response = await refreshParticipant()

        if (response !== libCon.OK)
            showErrorDialogByCode(response)
        else
            showNotification(i18n.t("refreshComplete"))

        setisSynching(false)
    }





    return (
        <div className='verticalSection'>
            {includeTitle ? <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t("perceptualSurvey")}</CustomText> : <div></div>}

            <CollectionStatus status={status} message={message} />

            <SimpleCopyField title={i18n.t("lastUploaded")} value={isNullOrUndefined(lastUploaded) ? i18n.t("never") : <>{`${formatToStudyLocationReadable(lastUploaded, true, false)}`}<br />{`(${formatDistanceShort(lastUploaded)})`}</>} enableCopy={false} />

            {
                isSynching
                    ? <CustomSpin type={locCon.BUTTON_SPINNER} />
                    : <CustomPrimaryButtonWithDisability isDisabled={isNullOrUndefined(participantId)} title={i18n.t("incompleteDeployment")} description={i18n.t("addEmailAndWearable")} onClick={() => refreshRecords()}>{i18n.t("refresh")}</CustomPrimaryButtonWithDisability>
            }


        </div>
    )
}

export default PerceptualSurveyStatusViewer
